import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './taxonomy.module.scss';
import { ObraProperties } from '../../../../types/ObraDetails';
import TitleHelp from '../../components/titleHelp/titleHelp';
import InfoBoxBoolean from '../../components/InfoBoxBoolean/InfoBoxBoolean';

interface TaxonomyProps {
  obra: ObraProperties,
}

const Taxonomy: FC<TaxonomyProps> = (props) => {
  const { obra } = props;
  const { t } = useTranslation();

  return (
    <div data-testid='esg-test' id='esg-nodata' className={styles.container}>
      <TitleHelp
        id='taxonomy'
        value={t('details.esg.taxonomy.helper')}
        help={t('help.esg.taxonomy')}
      />
      <div className={styles.sectionContainer}>
        <div className={styles.eligibility}>
          <InfoBoxBoolean
            identifier='eligibility'
            item={{ title: t('details.esg.taxonomy.eligibility'), value: obra.taxonomics?.eligibility ? t('details.esg.taxonomy.yes') : t('details.esg.taxonomy.no') }}
            value={obra.taxonomics?.eligibility ?? false}
            styles={
              { box: styles.eligibilityBox }
            }
          />
        </div>
      </div>
    </div>
  );
};


export default Taxonomy;
